import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import { deleteHold } from 'redux/clubMemberships/actions';

class DeleteHoldModal extends Component {
  handleDelete = (e) => {
    e.preventDefault();
    const { props } = this;
    const successFunction = () => {
      props.onCloseModal();
    };
    props.deleteHold(props.clubMembershipId, props.holdId, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { onCloseModal } = this.props;
    return (
      <Modal title="Remove Club Hold" onCloseModal={onCloseModal}>
        <p>
          Are you sure you want to remove the hold on your club?
          <br />
          To proceed click the remove button below.
        </p>
        <div className="c7-form__button-row">
          <a onClick={this.handleClose} className="c7-button-alt">
            Cancel
          </a>
          <button
            type="button"
            onClick={this.handleDelete}
            className="c7-button"
          >
            Remove Hold
          </button>
        </div>
      </Modal>
    );
  }
}

export default connect(null, {
  deleteHold
})(DeleteHoldModal);
